/* eslint semi:0 */
import React from 'react'
import { CURRENCY_DISPLAY_TYPES, } from '../transformers/fantasyTournamentTransformer'


function formatEntrySize(amount){
  return amount < 1000 ? amount : (amount / 1000).toFixed(2) + 'k'
}

function getEntryPerSize(currentEntriesCount, totalEntries){
  return formatEntrySize(currentEntriesCount) + '/' + formatEntrySize(totalEntries)
}

function getPriceString(amount, { value, type, }){
  if (type === CURRENCY_DISPLAY_TYPES.SYMBOL) {
    return value + amount
  }
  return amount + ' ' + value
}

export function FantasyTournament({
  blockName,
  tournament,
  onSelectTournament,
}){
  const classPrefix = `${ blockName }__tournament`
  const {
    title,
    currentEntriesCount,
    currency,
    totalEntries,
    entryFeeAmount,
    prizeAmount,
    link,
  } = tournament
  const entryPerSize = getEntryPerSize(currentEntriesCount, totalEntries)
  const entryFeeString = getPriceString(entryFeeAmount, currency)
  const entryPrizeString = getPriceString(prizeAmount, currency)
  const linkProps = {
    href: link,
    rel: 'noopener',
    target: '_blank',
    children: 'Enter',
    onClick: onSelectTournament,
    className: `${ classPrefix }-enter-link`,
  }
  return (
    <li className={ `${ classPrefix }` }>
      <h6 className={ `${ classPrefix }-title` }>{ title }</h6>
      <div className={ `${ classPrefix }-content-wrapper` }>
        <span className={ `${ classPrefix }-num-entries-wrapper` }>
          <label className={ `${ classPrefix }-num-entries-label` }>Entries/Size:</label>
          <span className={ `${ classPrefix }-num-entries-content` }>{ entryPerSize }</span>
        </span>
        <span className={ `${ classPrefix }-entry-fee-wrapper` }>
          <label className={ `${ classPrefix }-entry-fee-label` }>Entry:</label>
          <span className={ `${ classPrefix }-entry-fee-content` }>{ entryFeeString }</span>
        </span>
        <span className={ `${ classPrefix }-entry-prize-wrapper` }>
          <label className={ `${ classPrefix }-entry-prize-label` }>Prizes:</label>
          <span className={ `${ classPrefix }-entry-prize-content` }>{ entryPrizeString }</span>
        </span>
        <div className={ `${ classPrefix }-enter-container` }>
          <a { ...linkProps } />
        </div>
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/components/fantasyTournament.js